module.exports = __webpack_public_path__ + "img/template004.01207d96.png";